import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import Modali, { useModali } from "modali"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import ReCAPTCHA from "react-google-recaptcha"
import PhoneInput from "react-phone-number-input"

import api from "../core/sdk/networkInterface"
import Button from "../components/ui/Button"
import Form from "../components/ui/Form"
import TextInput from "../components/ui/TextInput"

export default function SignupForm() {
  // form inputs
  const [accountName, setAccountName] = useState("")
  const [domain, setDomain] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [referralKey, setReferralKey] = useState("")
  // form state
  const [submitting, setSubmitting] = useState(false)
  const [recaptchaCheck, setRecaptchaCheck] = useState(false)

  var ReCAPTCHA_API_KEY = "6LeYeecUAAAAAO2wf6ihL7vtJp_XLzrxDVcbGDPH"
  const [modal, toggleModal] = useModali({
    animated: true,
    closeButton: false,
    overlayClose: false,
    keyboardClose: false,
    centered: true,
  })
  function onChange(value) {
    if (value.length > 0) {
      setRecaptchaCheck(true)
    } else {
      setRecaptchaCheck(false)
    }
  }
  // auto-generate domain name from account name
  useEffect(() => {
    updateDomain(accountName)
  }, [accountName])
  useEffect(() => {
    var key = window.sessionStorage.getItem("referralKey")
    if (key && key != "undefined") {
      setReferralKey(key)
    }
  }, [])

  function updateDomain(name) {
    setDomain(
      name
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[^a-z0-9-]/gi, "")
    )
  }

  function ValidateEmail(mail) {
    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        mail
      )
    ) {
      return true
    }
    return false
  }

  function submit() {
    if (ValidateEmail(email)) {
      setSubmitting(true)
      toggleModal()

      api
        .post("/account/registerAjax/", {
          email,
          password,
          domain,
          first_name: firstName,
          last_name: lastName,
          account_name: accountName,
          phone_number: phoneNumber,
          referral_id: referralKey,
        })
        .then(response => {
          if (response.success) {
            window.location = "/"
          }
        })
        .catch(error => {
          // Display error message if user input is incorrect
          try {
            error.data.then(data => {
              toast.error(data.error)
            })
          } catch (e) {
            if (Math.floor(error.status / 100) === 4) {
              toast.error("Incorrect input")
            }
          }
          setSubmitting(false)
          toggleModal()
        })
    } else {
      toast.error("Invalid Email entered")
    }
  }

  return (
    <Form>
      <TextInput
        id="accountName"
        label="Company Name"
        required
        disabled={submitting}
        name="accountName"
        type="text"
        value={accountName}
        onChange={ev => setAccountName(ev.target.value)}
      />
      <TextInput
        id="domain"
        label="Domain Name"
        required
        disabled={submitting}
        name="domain"
        type="text"
        value={domain}
        onChange={ev => updateDomain(ev.target.value)}
      />
      <TextInput
        id="firstName"
        label="First Name"
        required
        disabled={submitting}
        name="firstName"
        type="text"
        value={firstName}
        onChange={ev => setFirstName(ev.target.value)}
      />
      <TextInput
        id="lastName"
        label="Last Name"
        required
        disabled={submitting}
        name="lastName"
        type="text"
        value={lastName}
        onChange={ev => setLastName(ev.target.value)}
      />
      <label for="accountName">
        Phone Number <span className="text-subtle">(Optional) </span>:
      </label>
      <PhoneInput
        placeholder="Enter phone number"
        value={phoneNumber}
        onChange={e => {
          setPhoneNumber(e)
        }}
        className="border-solid border-2 p-3 mb-4"
      />
      {/* <label for="accountName">                                       //can show referral key input location if needed
        Referral Key <span className="text-subtle">(Optional) </span>:
      </label>
      <TextInput
        id="referralKey"
        required
        disabled={submitting}
        name="referralKey"
        type="text"
        value={referralKey}
        onChange={ev => setReferralKey(ev.target.value)}
      /> */}
      <TextInput
        id="email"
        label="Email"
        required
        disabled={submitting}
        name="email"
        type="email"
        value={email}
        onChange={ev => setEmail(ev.target.value)}
      />
      <TextInput
        id="password"
        label="Password"
        required
        subtle="(Atleast 8 characters)"
        disabled={submitting}
        name="password"
        type="password"
        value={password}
        onChange={ev => setPassword(ev.target.value)}
      />
      <ReCAPTCHA
        sitekey={ReCAPTCHA_API_KEY}
        onChange={onChange}
        style={{ display: "flex", justifyContent: "center" }}
      />
      <Button
        primary
        className="w-full mt-4"
        disabled={submitting || !recaptchaCheck}
        margin="small"
        onClick={() => submit()}
      >
        Create Account
      </Button>
      <div className="text-md  text-subtle flex-row text-center pt-4">
        By signing up, you agree to Zenduty's{" "}
        <Link
          to="/terms/"
          className="font-bold text-md inline-flex items-center"
        >
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link
          to="/privacy/"
          className="font-bold text-md inline-flex items-center"
        >
          Privacy Policy
        </Link>
        .
      </div>

      <Modali.Modal {...modal}>
        <div className="text-center p-8">
          <div>Creating Account...</div>
          <Loader type="line-scale" active />
        </div>
      </Modali.Modal>
    </Form>
  )
}
